import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-campaigns-customers',
  storeModule.createStoreModule('active-offers-campaigns-customers')
)
